export default __webpack_public_path__ + "static/media/img--kitchen-2-light.f7d483fe.jpg";